import { ReactNode } from 'react';
import clsx from 'clsx';

export enum TagColor {
  blue = 'blue',
  yellow = 'yellow',
  gray = 'gray',
}

interface Props {
  className?: string;
  children: ReactNode;
  color?: 'purple' | 'blue' | 'green' | 'yellow' | 'red' | 'gray' | TagColor;
  small?: boolean;
}

export const Tag = ({
  className,
  children,
  color = 'purple',
  small = false,
}: Props) => {
  return (
    <div className={clsx(' inline-block shrink-0', className)}>
      <div className={clsx('tag', color, small && 'small')}>{children}</div>
    </div>
  );
};
